import helpers from "@/utils/helpers";
import { OptionsModal } from "./components/Options/index";
import { SearchModal } from "./components/Search/index";
import "./styles.scss";
import { Dialog, Transition } from "@headlessui/react";
import {
  RideGrid,
  RideGlError,
  RideIconButton,
  RideButton,
} from "@rimac-seguros/ride-system-components";
import React, { Fragment, useState } from "react";

export const ModalWithSearch = ({
  title,
  name,
  isOpen,
  defaultValue = "",
  iconResult = "",
  iconClose = true,
  iconCloseOutside = false,
  backDropClose = true,
  hasSearch,
  className,
  classNameContent,
  options,
  onClose,
  onConfirm,
  placeholder,
  virtualized,
  smallText,
}) => {
  const [currentValue, setCurrentValue] = useState(defaultValue);
  const [isFocus, setIsFocus] = useState(false);
  const isVE = helpers.validateVidaEndosable();

  const handleConfirm = (value) => {
    onConfirm(value);
    onClose();
    setIsFocus(false);
  };

  const handleClose = () => {
    onClose();
    setIsFocus(false);
  };

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog
        open={isOpen}
        onClose={() => {
          if (backDropClose) {
            onClose?.();
          }
        }}
        className="modal-with-search fixed inset-0 overflow-y-auto"
        as="div"
      >
        <Transition.Child
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Dialog.Overlay className="modal-with-search_overlay fixed w-screen bg-ride-sys-color-background-overlay lg:z-40" />
          <div
            className={`modal-with-search_content absolute z-50 w-full overflow-auto bg-ride-sys-color-background-default -translate-y-1/2 -translate-x-1/2 lg:h-auto lg:w-full lg:bg-transparent`}
          >
            <RideGrid
              className={`modal-with-search_grid h-full overflow-y-auto ${
                virtualized && !isFocus ? "no-scroll" : "custom-scroll"
              } lg:h-auto ${classNameContent || ""} ${isVE ? "is-ve" : ""}`}
            >
              <div
                className={`modal-with-search_grid-child relative col-span-full ${className ||
                  ""}`}
                onClick={(e) => e.stopPropagation()}
              >
                {!isFocus && (
                  <div
                    className={`modal-close ${!hasSearch && "without-border"}`}
                  >
                    <p>{hasSearch && title}</p>
                    {iconClose && !iconCloseOutside && (
                      <RideIconButton
                        className="iconButton"
                        glyph={<RideGlError />}
                        variant="unfill"
                        size="large"
                        onClick={handleClose}
                      />
                    )}
                  </div>
                )}

                {hasSearch && (
                  <SearchModal
                    title={title}
                    options={options || []}
                    isFocus={isFocus}
                    setIsFocus={setIsFocus}
                    iconResult={iconResult}
                    onSelect={handleConfirm}
                    placeholder={placeholder}
                  />
                )}

                {!hasSearch && (
                  <div className="modal-title">
                    <h3>{title}</h3>
                  </div>
                )}

                {!isFocus && (
                  <>
                    <OptionsModal
                      name={name}
                      options={options}
                      onSelect={setCurrentValue}
                      selected={currentValue}
                      virtualized={virtualized}
                      smallText={smallText}
                    />
                  </>
                )}

                <div className="modal-actions !fixed bottom-0">
                  {isVE && <div className="modal-actions__shadow" />}
                  <RideGrid>
                    <RideButton
                      text={"Confirmar"}
                      disabled={!currentValue}
                      size="large"
                      className="w-full col-span-full"
                      onClick={() => {
                        if (backDropClose) {
                          handleConfirm(currentValue);
                        }
                      }}
                    />
                  </RideGrid>
                </div>
              </div>
            </RideGrid>
          </div>
        </Transition.Child>
      </Dialog>
    </Transition>
  );
};
